<template>
  <section-collapseable
      ref="section"
      title="Buying Info"
      :sub-title="subtitle"
      :collapseable="isSet"
      hide-initial-when-expanded
      :is-loading="isLoading"
      second-button-text="View Comps"
      @secondButtonClick="openCompInfoModal"
  >
    <!-- Default Section -->
    <buying-info-flip-analysis v-if="isFlip" is-summary></buying-info-flip-analysis>

    <buying-info-wholesale-analysis v-else-if="isWholesale" is-summary></buying-info-wholesale-analysis>

    <form-field-select
        v-else-if="isNotSet"
        label="Would you like to buy via wholesale or fix & flip?"
        :value="analysisType"
        @input="setAnalysisType"
        :loading="typeIsLoading"
        :disabled="typeIsLoading"
    >
      <option :value="null">None</option>
      <option
          v-for="type in ENUMS.BuyingAnalysisTypeEnum"
          :key="type.value"
          :value="type.value"
      >{{ type.label }}</option>
    </form-field-select>

    <!-- Expanded Section -->
    <template v-slot:expanded>
      <form-field-select
          label="Buying Type"
          :value="analysisType"
          @input="setAnalysisType"
          :loading="typeIsLoading"
          :disabled="typeIsLoading"
      >
        <option :value="null">None</option>
        <option
            v-for="type in ENUMS.BuyingAnalysisTypeEnum"
            :key="type.value"
            :value="type.value"
        >{{ type.label }}</option>
      </form-field-select>

      <hr>
      <buying-info-flip-analysis v-if="isFlip"></buying-info-flip-analysis>
      <buying-info-wholesale-analysis v-if="isWholesale"></buying-info-wholesale-analysis>
    </template>

    <modal-container>
      <!-- Property Comps Modal -->
      <property-comps-modal
        ref="compsModal"
        :property="property"
      ></property-comps-modal>
    </modal-container>
  </section-collapseable>
</template>

<script>
import {ENUMS} from "../../../services/enums";
import BuyingInfoFlipAnalysis from "../components/BuyingInfoFlipAnalysis";
import BuyingInfoWholesaleAnalysis from "../components/BuyingInfoWholesaleAnalysis";
import InfoHeading from "../components/InfoHeading";
import InfoItem from "../components/InfoItem";
import ProfitItem from "../components/ProfitItem";
import api from "../../../api";
import PropertyCompsModal from "../PropertyCompsModal.vue";

export default {
  name: "LeadBuyingInfo",
  components: {
    PropertyCompsModal,
    ProfitItem,
    BuyingInfoWholesaleAnalysis,
    BuyingInfoFlipAnalysis,
    InfoHeading,
    InfoItem,
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      statusIsSaving: false,
      typeIsLoading: false,
    }
  },
  computed: {
    record() {
      // If activeRecord is null then return necessary empty info
      return this.$store.state.activeRecord ? this.$store.state.activeRecord.record : {
        id: null,
        buying_info_status: null,
        buying_analysis_id: null,
        buying_analysis_type: null,
        buying_info_accepted_at: null,
        buying_info_closing_at: null,
        buying_info_contracted_at: null,
      };
    },
    property() {
      return this.$store.state.activeRecord.property
    },
    buyingInfo() {
      return {
        id: this.record.id,
        record_id: this.record.id,
        buying_info_status: this.record.buying_info_status,

        buying_analysis_id: this.record.buying_analysis_id,
        buying_analysis_type: this.record.buying_analysis_type,

        buying_info_accepted_at: this.record.buying_info_accepted_at,
        buying_info_closing_at: this.record.buying_info_closing_at,
        buying_info_contracted_at: this.record.buying_info_contracted_at,
      }
    },
    analysisType() {
      return this.record.buying_analysis_type;
    },
    isNotSet() {
      return this.analysisType === null;
    },
    isSet() {
      return !!this.analysisType;
    },
    isFlip() {
      return this.analysisType === ENUMS.BuyingAnalysisTypeEnum.FixAndFlip.value;
    },
    isWholesale() {
      return this.analysisType === ENUMS.BuyingAnalysisTypeEnum.Wholesale.value;
    },
    subtitle() {
      if(this.isFlip) {
        return ENUMS.BuyingAnalysisTypeEnum.FixAndFlip.label;
      }

      if(this.isWholesale) {
        return ENUMS.BuyingAnalysisTypeEnum.Wholesale.label;
      }
    },
  },
  methods: {
    openCompInfoModal() {
      this.$refs.compsModal.open()
    },
    setAnalysisType(type) {
      this.typeIsLoading = true;

      if (type === null) {
        api.records.setActiveBuyingAnalysis(this.record.id, {})
        .finally(() => {
          this.typeIsLoading = false
          this.$refs.section.toggleSection();
        });
      }

      if(type === ENUMS.BuyingAnalysisTypeEnum.FixAndFlip.value) {
        const analysis = this.$store.state.activeRecord.fixAndFlipAnalysis;

        if(analysis) {
          api.records.setActiveBuyingAnalysis(this.record.id, analysis)
          .finally(() => this.typeIsLoading = false);
        } else {
          api.analysis.createFixAndFlipAnalyses({
            record_id: this.record.id,
            after_repair_value: null,
            repair_costs: null,
            holding_costs: null,
            holding_time: null,
            other_costs: null,
            desired_profit: null,
          }).finally(() => this.typeIsLoading = false);
        }
      }

      if(type === ENUMS.BuyingAnalysisTypeEnum.Wholesale.value) {
        const analysis = this.$store.state.activeRecord.wholesaleAnalysis;

        if(analysis) {
          api.records.setActiveBuyingAnalysis(this.record.id, analysis)
          .finally(() => this.typeIsLoading = false);
        } else {
          api.analysis.createWholesaleAnalyses({
            record_id: this.record.id,
            after_repair_value: null,
            desired_wholesale_fee: null,
            offer_percentage: null,
            other_costs: null,
            repair_costs: null,
          }).finally(() => this.typeIsLoading = false);
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

hr {
  margin: 0.75rem (-$modalGutter);
}
</style>
